import { SendWelcomeEmail } from '@src/services/base'
import { GetPedagogicTypeList } from '@src/services/form'
import { getSavedState, saveState } from '@src/utils/localStorage'
import { i18n } from '@src/plugins'
import { ProfileGet } from '@src/services/utils'
import VueInstance from 'vue'
import Vue from '@src/main.js'

export const state = {
    currentLanguage: getSavedState('user.currentLanguage'),
    isLoading: false,
    profilesList: [],
    pedagogicTypeList: [],
    pageTitle: '',
    isRightPanelOpen: false,
    isOverlayActive: false,
    ecommerceLegacyInfoAuth: getSavedState('auth.ecommerceLegacy.info'),
}
export const mutations = {
    SET_CURRENT_LANGUAGE(state, newValue) {
        state.currentLanguage = newValue
        saveState('user.currentLanguage', newValue)
    },
    SET_LOADING(state, newValue) {
        state.isLoading = newValue
    },
    SET_PROFILES_LIST(state, profiles) {
        state.profilesList = profiles
    },
    SET_TITLE(state, title) {
        state.pageTitle = title
    },
    SWITCH_STATUS(state, profile) {
        state.profilesList.find(({ enumProfile }) => {
            return enumProfile === profile.enumProfile
        }).status = !profile.status
        VueInstance.set(state, 'profilesList', [...state.profilesList])
    },
    SET_PEDAGOGIC_TYPE(state, newList) {
        state.pedagogicTypeList = newList
    },
    TOGGLE_RIGHT_PANEL(state) {
        state.isRightPanelOpen = !state.isRightPanelOpen
    },
    CLOSE_RIGHT_PANEL(state) {
        state.isRightPanelOpen = false
    },
    SET_OVERLAY(state, value) {
        state.isOverlayActive = value
    },
    SET_ECOMMERCE_LEGACY_INFO_AUTH(state, value) {
        state.ecommerceLegacyInfoAuth = value
        saveState('auth.ecommerceLegacy.info', value)
    },
}

export const getters = {}

export const actions = {
    async init({ dispatch }) {
        if (!getSavedState('user.currentLanguage')) {
            const defaultLanguage = checkLanguage(navigator.language)
            dispatch('setCurrentLanguage', defaultLanguage)
        }
        // HACKY: trocar as linguagens esES para esCL
        if (getSavedState('user.currentLanguage') === 'esES')
            dispatch('setCurrentLanguage', 'esCL')
        if (
            getSavedState('auth.token') &&
            !window.location.pathname.match(/reset-password/)
        )
            // dispatch('setLevelList')
            console.log('initBaseModule')
    },
    setLoading({ commit }, status) {
        commit('SET_LOADING', status)
    },

    async setPedagogicType({ commit }, parameters = {}) {
        const resp = await GetPedagogicTypeList(parameters)
        if (resp.status === 200) {
            commit('SET_PEDAGOGIC_TYPE', resp.data.data.items)
            return true
        }
        return false
    },

    setCurrentLanguage({ commit }, parameters) {
        commit('SET_CURRENT_LANGUAGE', parameters)
        i18n.locale = parameters
    },

    async getProfilesList({ commit }, persona) {
        await ProfileGet(persona).then((resp) => {
            if (resp.status === 200) {
                const allProfiles = Array.from(Vue.$t('Profiles'))
                const personaProfile = allProfiles.filter(({ value }) =>
                    resp.data.data.some(
                        ({ enumProfile }) => parseInt(value) === enumProfile
                    )
                )
                personaProfile.forEach((profile) => {
                    profile.enumProfile = parseInt(profile.value)
                    profile.status = false
                })
                commit('SET_PROFILES_LIST', personaProfile)
            }
            return resp
        })
    },

    switchProfileStatus({ commit }, profile) {
        commit('SWITCH_STATUS', profile)
    },

    setPageTitle({ commit }, title) {
        commit('SET_TITLE', title)
    },
    toggleRightPanel({ commit }) {
        commit('TOGGLE_RIGHT_PANEL')
    },
    closeRightPanel({ commit }) {
        commit('CLOSE_RIGHT_PANEL')
    },
    setOverlay({ commit }, overlay) {
        commit('SET_OVERLAY', overlay)
    },
    setEcommerceLegacyInfoAuth({ commit }, overlay) {
        commit('SET_ECOMMERCE_LEGACY_INFO_AUTH', overlay)
    },

    async sendWelcomeEmail(_, userInfo) {
        const resp = await SendWelcomeEmail(userInfo)
        return resp
    },
}

// ===
// Private helpers
// ===

function checkLanguage(language) {
    return (
        {
            ptBr: 'ptBR',
            enUs: 'enUS',
            esEs: 'esES',
        }[language] || 'ptBR'
    )
}
